import React from "react"

const SuccessIconGreenFill = () => {
  return (
    <span className="inline-flex items-center justify-center w-6 h-6 rounded-md text-white shadow-md bg-gradient-to-br from-green-400 via-green-500 to-green-700">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </span>
  );
};

export default SuccessIconGreenFill;
